import http from './public'

var passport = "/api/web/passport/"
export const login = (params) => { //登录
    return http(`${passport}login`, params)
}
//
export const loginPic = (params) => { //验证码
    return http(`/api/common/syscom/loginPic`, params)
}
export const userPwdResetSms = (params) => { //验证码
    return http(`/api/web/userCenter/userPwdResetSms`, params)
}



export const queryRegisterCompanySms = (params) => { //验证码
    return http(`/api/web/userCenter/queryRegisterCompanySms`, params)
}
export const createRegisterCompanySms = (params) => { //验证码
    return http(`/api/web/passport/createRegisterCompanySms`, params)
}
export const userPwdModifySms = (params) => { //当前用户修改密码短信获取
    return http(`/api/web/userCenter/userPwdModifySms`, params)
}
export const userPwdModify = (params) => { //当前用户修改密码
    return http(`/api/web/userCenter/userPwdModify`, params)
}


export const userPwdReset = (params) => { //用户重置密码
    return http(`/api/web/userCenter/userPwdReset`, params)
}

export const userAccountExists = (params) => { //检查当前注册用户是否可用
    return http(`/api/web/passport/userAccountExists`, params)
}
export const companyRegisterStatus = (params) => { // 查询企业是否已注册
    return http(`/api/web/passport/companyRegisterStatus`, params)
}
export const companyRegisterInfo = (params) => { // 查询待修改企业
    return http(`/api/web/passport/companyRegisterInfo`, params)
}

export const login2 = (params) => { //后台登录
    return http(`/api/admin/passport/login`, params)
}

export const registerCompany = (params) => { //企业注册
    return http(`${passport}registerCompany`, params)
}
export const profile = (params) => { //获取我的信息
    return http(`/api/common/syscom/profile`, params)
}

export const querySysComByTypePageReq = (params) => { //企业分页列表
    return http(`/api/common/syscom/querySysComByTypePageReq`, params)
}

export const querySysCompanyPageByManage = (params) => { //企业分页列表
    return http(`/api/common/syscom/querySysCompanyPageByManage`, params)
}
export const queryThirdProjectPage = (params) => { //工程接口
    return http(`/api/common/third/queryThirdProjectPage`, params)
}

export const queryThirdProjectInfoPage = (params) => { //查询工程信息分页列表
    return http(`/api/common/third/queryThirdProjectInfoPage`, params)
}
export const queryThirdProjectDetail = (params) => { //查询工程信息详情
    return http(`/api/common/third/queryThirdProjectDetail`, params)
}


export const queryInsureCategoryList = (params) => { //查询IDI险种列表
    return http(`/api/common/insurecategory/queryInsureCategoryList`, params)
}

export const querySafeClaimsAccidentList = (params) => { //查询安责险事故类型列表
    return http(`/api/common/safeclaimsaccident/querySafeClaimsAccidentList`, params)
}

export const queryComTenantList = (params) => { //查询所有租户
    return http(`/api/common/tenant/queryComTenantList`, params)
}



export const queryThirdProjectByTenantPage = (params) => { //租户查询工程信息分页列表
    return http(`/api/common/third/queryThirdProjectByTenantPage`, params)
}

export const rolePage = (params) => { //角色管理
    return http(`/api/web/userCenter/rolePage`, params)
}
export const roleCreate = (params) => { //角色管理
    return http(`/api/web/userCenter/roleCreate`, params)
}
export const roleEdit = (params) => { //角色管理
    return http(`/api/web/userCenter/roleEdit`, params)
}
export const addInsureComEntryTisDetail = (params) => { //保险公司录入TIS机构信息
    return http(`/api/web/userCenter/addInsureComEntryTisDetail`, params)
}
export const roleDelete = (params) => { //删除角色
    return http(`/api/web/userCenter/roleDelete`, params)
}

export const provinces = (params) => { //获取省份
    return http(`/api/common/provinceCityArea/provinces`, params)
}
export const cities = (params) => { //获取地市
    return http(`/api/common/provinceCityArea/cities`, params)
}
export const areas = (params) => { //获取区县
    return http(`/api/common/provinceCityArea/areas`, params)
}

export const resetPwdInsureComEntryTis = (params) => {//重置TIS机构管理员密码
    return http(`/api/web/userCenter/resetPwdInsureComEntryTis`, params)
}
export const addThirdProjectDetailByTenant = (params) => { //根据工程编号同步工程信息
    return http(`/api/common/third/addThirdProjectDetailByTenant`, params)
}
export const qeryInsureComEntryTisList = (params) => { //保险公司查询TIS机构分页列表
    return http(`/api/web/userCenter/qeryInsureComEntryTisList`, params)
}
//查询TIS机构切换账号信息
export const queryTisSwitchAccountInfo = (params) => {
    return http(`/api/web/userCenter/queryTisSwitchAccountInfo`, params)
}
//TIS机构切换账号刷新令牌
export const refreshTisSwitchAccountToken = (params) => {
    return http(`/api/web/userCenter/refreshTisSwitchAccountToken`, params)
}
